import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import Icons from "../svg/Icons.ts";
import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.ts";
import * as segment from "../tracking-segment.ts";

import theModalTpl from "./file-viewer.mustache";

var modalViewFile: HTMLElement | null = null;

// the viewer is shared by every feature: only the gallery and the file manager are tracked
const GALLERY_VIEWER_GROUPS = ['photos-gallery','modal-gallery'];
function isGalleryPhoto(group: string): boolean {
  return GALLERY_VIEWER_GROUPS.includes(group);
}
function isFilerFile(file, group?: string): boolean {
  return !!file?.parentFolderId && !isGalleryPhoto(group);
}

Html.registerDom({
  async fileview(after){
    const
      metaId = Html.getDomMetaId(this),
      file = FwDatas.getIMedia(metaId),
      group = this.getAttribute('data-media-viewer-group'),
      groupNodes = Array.from(document.querySelectorAll<HTMLElement>(`[data-media-viewer-group="${group}"]`)).filter(otherNode=>{
        return otherNode==this || Html.getDomMetaId(otherNode)!==metaId
      }),
      groupFiles = groupNodes.map(otherNode=>FwDatas.getIMedia(Html.getDomMetaId(otherNode)));

    let index = groupFiles.indexOf(file);

    if(!file) {
      return;
    }
    //check premium rights if it is not an image
    if(!file.isImage()){
      let state = FwDatas.getState()
      if(file.isAudio()){
        if(!state.premium.audio){
          Html.trigger(this,'takepremium');
          return;
        }
      } else if(file.isVideo()){
        if(!state.premium.videoAvailable){
          Html.trigger(this,'takepremium');
          return;
        }
      } else if(FwDatas.getPermission('filer')!=='OK'){
        Html.trigger(this,'takepremium');
        return;
      }
    }

    modalViewFile = modal.openDomModal(theModalTpl,{
      prev:groupFiles[index-1],
      next:groupFiles[index+1],
      file
    });
    if(isGalleryPhoto(group)){
      segment.track("Photo Viewed");
    }else if(isFilerFile(file,group)){
      segment.track("File Viewed",{file_type:file.mimeType});
    }

    modalViewFile.querySelectorAll('img.main-image').forEach((imgNode: HTMLImageElement)=>{
      imgNode.addEventListener('load',function(){
        imgNode.style.border="20px solid white";
        if(imgNode.nextSibling?.parentNode){
          imgNode.nextSibling.parentNode.removeChild(imgNode.nextSibling)
        }
      })
    });

    if(after==='print'){
      modalViewFile.querySelectorAll('img').forEach((imgNode: HTMLImageElement)=>{
        imgNode.addEventListener('load',function(){
          window.print();
        })
      });
    }

    modalViewFile.addEventListener('click', Html.createDelegateListener(
      '[navigation]',
      function(event, target){
        event.stopPropagation();
        index += parseInt(target.getAttribute('navigation')!);
        modal.closeDomModal(modalViewFile!);
        Html.trigger(groupNodes[index],'fileview')
      }
    ));
  },
  filedownload(){
    const file = FwDatas.getIMedia(Html.getDomMetaId(this));
    if(file.isImage() && !file.parentFolderId){
      segment.track("Photo Downloaded");
    }
    window.open(file.pictureUrl+'&download');
  },
  async filesend(){
    try{
      const
      file = FwDatas.getIMedia(Html.getDomMetaId(this)),
      blob =  await fetch(file.pictureUrl).then(r => r.blob());
    const shared = await navigator.share({
       text:file.name,
       files:[new File([blob],file.name,
       {type:file.mimeType})]
     })
    if(isFilerFile(file)){
      segment.track("File Shared");
    }
    return shared;
    }catch(e){
      modal.oops('fw2.defaultError')
    }
  },
  async filedelete(){
    const
      file = FwDatas.getIMedia(Html.getDomMetaId(this));

    if(!await modal.confirmDelete("files.confirmdeletefile")) return;

    await ApiServer.filerdeletefile(file.metaId).then(()=>{
      if(isFilerFile(file)){
        segment.track("File Deleted");
      }
      modal.toastDone('files.toastfiledeleted',file)
    })
    //for closing the file viewer
    modal.closeDomModal();
    amplify.publish('mediaDeleted',file.metaId);
    document.querySelectorAll(`[data-fw-meta-id="${file.metaId}"]`).forEach(el=>el.remove())

  },

});
actionMenu.register({
  filemenu(){
    const
      metaId = Html.getDomMetaId(this),
      file = FwDatas.getIMedia(metaId),
      buttons = [];
    if(file.parentFolderId){
      if(file.rights.canUpdate){
        buttons.push({onclick:'fileedit',svg:Icons.ic_edit,i18nkey:'actions.rename'})
        buttons.push({onclick:'filemove',svg:Icons.filer.ic_file_move,i18nkey:'actions.move'})
      }
      buttons.push({onclick:'fileduplicate',svg:Icons.ic_duplicate,i18nkey:'actions.duplicate'})
    }
    buttons.push({onclick:'filedownload',svg:Icons.ic_download,i18nkey:'actions.download'})
    buttons.push({onclick:'filesend',svg:Icons.ic_send,i18nkey:'actions.send'})

    if(file.isImage()){
      if(modalViewFile && modalViewFile.parentNode){
        buttons.push({onclick:'print',svg:Icons.ic_print,i18nkey:'actions.print'})
      }else{
        buttons.push({onclick:'fileview|print',svg:Icons.ic_print,i18nkey:'actions.print'})
      }
    }
    if(file.rights.canDelete){
      if(file.pointedBy && FwDatas.get(file.pointedBy) && !(FwDatas.get(file.pointedBy)?.rights.canDelete)){
        buttons.push({onclick:'notadminmodal',svg:Icons.ic_delete,i18nkey:'actions.delete',color:'var(--red)'})
      }else{
        buttons.push({onclick:'filedelete',svg:Icons.ic_delete,i18nkey:'actions.delete',color:'var(--red)'})
      }

    }

    return {'menu':buttons}
  }

})
function close(){
  modal.closeDomModal(modalViewFile!);
} 

export {close}